import { useEffect, useState } from 'react'

// Turns markdown into HTML (the library loads on first use, so it stays out of the main download).
// Only ever used on our own documents in the repo, never on user text.
export function useMarkdownHtml(markdown: string): string {
  const [html, setHtml] = useState('')
  useEffect(() => {
    let cancelled = false
    void import('marked').then(async ({ marked }) => {
      const rendered = await marked.parse(markdown)
      if (!cancelled) setHtml(rendered)
    })
    return () => { cancelled = true }
  }, [markdown])
  return html
}
